(function () {
  const roots = document.querySelectorAll('[data-community-gallery-mobile]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    const gallery = root.querySelector('[data-community-gallery-track]');
    const dots = root.querySelectorAll('[data-community-gallery-dot]');
    const slides = root.querySelectorAll('[data-community-gallery-slide]');
    const errorNode = root.querySelector('[data-community-gallery-error]');

    function getStride() {
      if (slides.length < 2) {
        return slides[0]?.offsetWidth || 0;
      }
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getMaxScroll() {
      if (!gallery) return 0;
      return Math.max(0, gallery.scrollWidth - gallery.clientWidth);
    }

    function clampScroll() {
      if (!gallery) return;
      const maxScroll = getMaxScroll();
      if (gallery.scrollLeft < 0) {
        gallery.scrollLeft = 0;
      } else if (gallery.scrollLeft > maxScroll) {
        gallery.scrollLeft = maxScroll;
      }
    }

    function getActiveIndex() {
      if (!gallery || !slides.length) return 0;

      const scrollLeft = gallery.scrollLeft;
      let activeIndex = 0;
      let bestDistance = Infinity;

      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function updateDots() {
      if (!dots.length) return;

      const activeIndex = getActiveIndex();
      dots.forEach(function (dot, index) {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function scrollToSlide(index) {
      if (!gallery || !slides[index]) return;

      const maxScroll = getMaxScroll();
      const slideOffset = slides[index].offsetLeft;
      const targetLeft = Math.min(Math.max(0, slideOffset), maxScroll);

      gallery.scrollTo({
        left: targetLeft,
        behavior: 'smooth',
      });
    }

    function playActiveSlideVideo() {
      const activeIndex = getActiveIndex();
      const activeSlide = slides[activeIndex];
      if (!activeSlide) return;

      const video = activeSlide.querySelector('video');
      if (!video) return;

      slides.forEach(function (slide, index) {
        if (index === activeIndex) return;
        const otherVideo = slide.querySelector('video');
        if (otherVideo && !otherVideo.paused) {
          otherVideo.pause();
        }
      });

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.play().catch(function () {});
    }

    gallery?.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(function () {
          clampScroll();
          updateDots();
        });
      },
      { passive: true }
    );

    gallery?.addEventListener(
      'scrollend',
      function () {
        clampScroll();
        updateDots();
        playActiveSlideVideo();
      },
      { passive: true }
    );

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        scrollToSlide(index);
      });
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(function () {
        clampScroll();
        updateDots();
      });
    });

    document.addEventListener('cart:updated', function () {
      if (!errorNode) return;
      errorNode.hidden = true;
      errorNode.textContent = '';
    });

    gallery?.scrollTo({ left: 0 });
    clampScroll();
    updateDots();
    window.requestAnimationFrame(function () {
      playActiveSlideVideo();
    });
  });
})();
